import { SkeletonLoader } from '../Common/SkeletonLoader';
import { useIsMobile } from '@/hooks/useIsMobile';

const TopWrapperSkeleton = () => {
  const isMobile = useIsMobile();
  return (
    <div className="w-full h-full bg-base-content rounded-xl p-6 md:p-8">
      <div className="flex flex-col gap-8 w-full max-w-4xl mx-auto">
        <div className="flex items-center gap-4 justify-between">
          <div className="flex items-center gap-4">
            <SkeletonLoader width="w-11" height="h-11" />
            <SkeletonLoader width="w-24" height="h-5" />
          </div>
          {isMobile && (
            <div className="flex items-center gap-2">
              <SkeletonLoader width="w-12" height="h-3" />
              <SkeletonLoader width="w-3" height="h-3" />
            </div>
          )}
        </div>

        <div className="flex flex-col gap-5">
          <div className="flex items-center justify-between gap-4">
            <div className="flex items-center gap-4">
              <SkeletonLoader width="w-9" height="h-9" />
              <SkeletonLoader width="w-14" height="h-5" />
            </div>
            <SkeletonLoader width="w-14" height="h-5" />
          </div>

          {!isMobile && (
            <div className="flex items-center justify-between gap-4">
              <div className="flex items-center gap-4">
                <SkeletonLoader width="w-9" height="h-9" />
                <SkeletonLoader width="w-16" height="h-5" />
              </div>
              <SkeletonLoader width="w-12" height="h-5" />
            </div>
          )}

          {!isMobile && (
            <div className="flex items-center justify-between gap-4">
              <div className="flex items-center gap-4">
                <SkeletonLoader width="w-9" height="h-9" />
                <SkeletonLoader width="w-12" height="h-5" />
              </div>
              <SkeletonLoader width="w-10" height="h-5" />
            </div>
          )}
        </div>

        {!isMobile && (
          <>
            <SkeletonLoader height="h-10" />

            <div className="flex items-center justify-between gap-4">
              <SkeletonLoader width="w-20" height="h-6" />
              <SkeletonLoader width="w-14" height="h-6" />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default TopWrapperSkeleton;
